import {
  Grid,
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import { FC, RefObject, useEffect, useState } from 'react'

import useAuth from '@hook/shared/use-auth'

import type { ILinkMenu } from '@base/@types/components/Layout/Navigator'

import DropdownItem from './DropdownItem'

interface INavigatorDropdownProps {
  id: string
  group: string
  isOpen: boolean
  right?: boolean
  left?: boolean
  menu: ILinkMenu[]
  dropdownRef: RefObject<HTMLDivElement>
}

const NavigatorDropdown: FC<INavigatorDropdownProps> = ({
  id,
  isOpen,
  menu,
  group,
  dropdownRef
}) => {
  const { role, companies } = useAuth()
  const [position, setPosition] = useState({ top: 0, left: 0 })

  useEffect(() => {
    if (isOpen && dropdownRef?.current) {
      const rect = dropdownRef.current.getBoundingClientRect()
      setPosition({
        top: rect.bottom + window.scrollY, // para compensar scroll
        left: rect.left + window.scrollX
      })
    }
  }, [isOpen, dropdownRef])

  return (
    <Modal id={id} isOpen={isOpen} onClose={() => {}} size="6xl">
      <ModalOverlay />

      <ModalContent
        position="absolute"
        top={`${position.top}px`} // <- usar valor real
        left={`${position.left}px`}
        background="white"
        width={['100%', '400px', '400px']}
        margin={0}
      >
        <ModalHeader
          paddingY={1}
          paddingLeft={4}
          fontSize={16}
          textColor="gray.200"
          background="#1d5840"
          borderTopLeftRadius={5}
          borderTopRightRadius={5}
          borderBottom="3px solid #ECC94B"
        >
          {group}
        </ModalHeader>

        <Grid templateColumns="repeat(2, 1fr)" padding={2}>
          {menu.map((item, index) => {
            const roleOk = !item.roles || item.roles.includes(role)
            const companyOk =
              role === 'Administrador' ||
              !item.companies ||
              item.companies.some(c => (companies ?? []).includes(c))
            return roleOk && companyOk ? (
              <DropdownItem key={`${id}--submenu-${index}`} {...item} />
            ) : null
          })}
        </Grid>
      </ModalContent>
    </Modal>
  )
}

export default NavigatorDropdown
